import React from 'react';
import CustomizerTest from 'src/components/widgets/customizerTest/customizerTest';
import { useProductConfigurationState } from '../../state';

const done = () => {
    const { state } = useProductConfigurationState();

    return <CustomizerTest productId={state.product.id!} isClassic />;
};

export default done;
